
//Defines all the Currencies available in the app.
//IMPORTANT: Must be mapped to each specific currency code to work properly.
export enum CurrencyCodeValue {
  Euro = 'EUR',
  BritishPound = 'GBP',
}
